// extracted by mini-css-extract-plugin
export default {"statusWrapper":"Statuses_statusWrapper__0sRXo","withoutLabel":"Statuses_withoutLabel__UPJ5P"};